import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { FaxBackAccount } from '../../../../models/faxback.model';
import { UpdateUserServiceCode } from '@voice/utils';
import { FaxAuditService } from '../../../../services/fax-audit.service';
import { FAX_AUDIT_MESSAGES } from '../constants/fax-audit.constants';

export interface UpdateResult {
  success: boolean;
  message: string;
}

@Injectable({
  providedIn: 'root',
})
export class FaxAuditUpdateService {
  constructor(private readonly faxAuditService: FaxAuditService) {}

  updateAccounts(
    accounts: FaxBackAccount[],
  ): Observable<UpdateResult> {
    const updates = this.mapAccountsToUpdates(accounts);
    return this.faxAuditService.updateUsersServiceCode(updates).pipe(
      map((results: UpdateUserServiceCode[]) => {
        return this.createUpdateResult(results);
      }),
    );
  }

  private mapAccountsToUpdates(
    accounts: FaxBackAccount[],
  ): Array<{
    domainId: string;
    userId: string;
    faxType: string;
  }> {
    return accounts.map((account) => ({
      domainId: account.domainId,
      userId: account.accountIdNumeric,
      faxType: account.faxType,
    }));
  }

  private createUpdateResult(
    results: UpdateUserServiceCode[],
  ): UpdateResult {
    const errorCount = results.filter((result) => result.status === 'error')
      .length;
    const success = errorCount === 0;

    return {
      success,
      message: success
        ? FAX_AUDIT_MESSAGES.ALL_UPDATED
        : FAX_AUDIT_MESSAGES.SOME_FAILED,
    };
  }
}
